import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import SelectionProcessDashboard from './SelectionProcessDashboard';

const SelectionProcessIndex = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <div className="MainDivCard" style={{ backgroundColor: '#f5f5f5' }}>
        <div className="col-sm-12">
          <Row>
            <Col xs={10}>
              <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
                <span style={{ color: '#2bb48f' }}>Dashboard</span> Reclutamiento y Selección
              </p>
            </Col>
          </Row>
        </div>

        <div className="col-sm-12 MainDivHrCard">
          <SelectionProcessDashboard />
        </div>
      </div>
    </>
  );
};

export default SelectionProcessIndex;
